export const buildProjectEntityStatusUpdatePayload = (status) => ({
  status: String(status || "").trim(),
});
